import { IReview } from '@curbnturf/entities';
import { Action, createReducer, on } from '@ngrx/store';
import { v4 as uuidv4 } from 'uuid';
import * as ReviewsActions from './reviews.actions';

export interface ReviewState {
  listingReviews: { [syncId: string]: IReview };
  guestReviews: { [syncId: string]: IReview };
  boondockReviews: { [syncId: string]: IReview };
  poiReviews: { [syncId: string]: IReview };
  currentGuestReview?: IReview;
  loaded: boolean; // has the Review list been loaded
  error?: string; // last error (if any)
}

export const initialState: ReviewState = {
  listingReviews: {},
  guestReviews: {},
  boondockReviews: {},
  poiReviews: {},
  loaded: false,
};

const reviewsReducer = createReducer(
  initialState,
  on(ReviewsActions.loadListingReviewsSuccess, (state, { reviews }) => {
    let listingReviews = {};
    reviews.forEach((el) => {
      listingReviews = { ...listingReviews, [el.syncId || uuidv4()]: el };
    });
    return {
      ...state,
      listingReviews,
    };
  }),
  on(ReviewsActions.storeGuestReview, (state, { review }) => {
    return {
      ...state,
      currentGuestReview: review,
    };
  }),
  on(ReviewsActions.createGuestReviewSuccess, (state) => {
    return {
      ...state,
      currentGuestReview: undefined,
    };
  }),
  on(ReviewsActions.loadListingReviewsFailure, (state, { error }) => ({
    ...state,
    error: error.error?.message || error.message || error,
  })),
  on(ReviewsActions.loadGuestReviewsSuccess, (state, { reviews }) => {
    let guestReviews = {};
    reviews.forEach((el) => {
      guestReviews = { ...guestReviews, [el.syncId || uuidv4()]: el };
    });
    return {
      ...state,
      guestReviews,
    };
  }),
  on(ReviewsActions.loadGuestReviewsFailure, (state, { error }) => ({
    ...state,
    error: error.error?.message || error.message || error,
  })),
  on(ReviewsActions.loadBoondockReviewsSuccess, (state, { reviews }) => {
    let boondockReviews = {};
    reviews.forEach((el) => {
      boondockReviews = { ...boondockReviews, [el.syncId || uuidv4()]: el };
    });
    return {
      ...state,
      boondockReviews,
    };
  }),
  on(ReviewsActions.loadBoondockReviewsFailure, (state, { error }) => ({
    ...state,
    error: error.error?.message || error.message || error,
  })),
  on(ReviewsActions.loadPoiReviewsSuccess, (state, { reviews }) => {
    let poiReviews = {};
    reviews.forEach((el) => {
      poiReviews = { ...poiReviews, [el.syncId || uuidv4()]: el };
    });
    return {
      ...state,
      poiReviews,
    };
  }),
  on(ReviewsActions.loadPoiReviewsFailure, (state, { error }) => ({
    ...state,
    error: error.error?.message || error.message || error,
  })),
);

export function reducer(state: ReviewState | undefined, action: Action) {
  return reviewsReducer(state, action);
}
